import { send } from 'server';

export const getRgConfiguration = () => send({
    ID: 32942,
    responses: [32943, 32944],
    description: 'Get Responsible Gaming Configuration',
    type: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
});

export const getPlayerLimitsHistory = ({ startDate, descriptions }) => send({
    ID: 35787,
    responses: [35788, 35789],
    description: 'Get player limits history',
    startDate,
    descriptions
});
